import React from 'react';
import { Route } from 'react-router-dom';
import AgentDashboardRoutes from './AgentDashboard/routes';
const routes = () => [<AgentDashboardRoutes key="AgentDashboardRoutes" />];

const AgentDashboardRoute = () => <Route component={routes} />;

export default AgentDashboardRoute;



// WEBPACK FOOTER //
// src/modules/screens/agentdashboard/routes.js